import classNames from "classnames";
import { Link } from "react-router-dom";
import { WithTooltip } from "../tooltips/with_tooltip";

export function DisableableLink(
	props: React.ComponentProps<typeof Link> & {
		is_disabled?: boolean;
		tooltip?: string;
	}
) {
	const { is_disabled, tooltip, ...pure_props } = props;

	const link = (
		<Link
			{...pure_props}
			className={classNames(props.className, {
				"input-disabled pointer-events-none text-gray-400": is_disabled,
				"manual-link": !is_disabled,
			})}
		/>
	);

	if (props.tooltip) {
		return (
			<WithTooltip style="Info" tooltip={tooltip} disable_click>
				{link}
			</WithTooltip>
		);
	}

	return link;
}
